import { render, staticRenderFns } from "./InputInboxNeedRevision.vue?vue&type=template&id=de6ae4e0&scoped=true&"
import script from "./InputInboxNeedRevision.vue?vue&type=script&lang=js&"
export * from "./InputInboxNeedRevision.vue?vue&type=script&lang=js&"
import style0 from "./InputInboxNeedRevision.vue?vue&type=style&index=0&id=de6ae4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6ae4e0",
  null
  
)

export default component.exports